import { defineFrontendModule } from '~/lib/module';

defineFrontendModule({
  name: 'marketing',
  owner: 'app',
  scope: ['frontend'],
  description: 'Public about page.',
});
